import { useState, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";
import Pagination from "@mui/material/Pagination";
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import DataTable from "examples/Tables/DataTable";

import toast from "react-hot-toast";
import moment from "moment";
import { capitalCase } from "capital-case";

import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";
import SharedContentContext from "context/shared-content";

import Prompt from "components/UpStyled/Prompt";
import api from "services/api";

import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import { Empty } from "antd";
import { compare } from "utils/helper";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

const SharedCollectionList = ({ size = 60, limit, tableOptions = {} }) => {
  const [collectionList, setCollectionList] = useState([]);
  const [filteredCollections, setFilteredCollections] = useState([]);

  const navigate = useNavigate();

  const account = useContext(AccountContext);
  const { resourceList, permissionMap } = useContext(SharedContentContext);

  useEffect(() => {
    retrieveCollections();
  }, [resourceList]);

  const retrieveCollections = async () => {
    try {
      const { data } = await api.collections.sharedList();

      let myCollections = data?.collections || [];
      const sharedToAllIds = resourceList
        .filter((x) => x.user_id == "AllDesigners")
        .map((x) => x.resource_id);
      myCollections = myCollections.filter((x) => sharedToAllIds.includes(x.id));
      myCollections = myCollections.sort((a, b) => compare(a, b, "-updated_at"));
      if (limit) {
        myCollections = myCollections.slice(0, limit);
      }

      setCollectionList(myCollections || []);
      setFilteredCollections(myCollections || []);
    } catch (err) {
      toast.error(`Retrieve collection list failed`);
      console.log(err);
    }
  };

  return (
    <SuiBox>
      <SuiBox sx={{ overflow: "auto" }}>
        {filteredCollections.length > 0 ? (
          <ResponsiveMasonry columnsCountBreakPoints={{ 300: 1, 550: 2, 850: 3, 1200: 4, 1400: 5 }}>
            <Masonry gutter="16px">
              {filteredCollections.map((mb) => {
                const image = mb?.moodboard?.[0]?.img;
                return (
                  <SuiBox>
                    <div>
                      <SuiBox
                        onClick={(e) => {
                          navigate(`/shared-with-me/collections?id=${mb.id}`);
                        }}
                        sx={{
                          cursor: "pointer",

                          overflow: "hidden",
                          position: "relative",
                          display: "flex",
                          minWidth: 0,
                          width: "100%",
                          height: 234,
                        }}
                        className="hover-parent"
                      >
                        <ImageCardWrapper
                          data={image}
                          height={234}
                          width={"100%"}
                          draggable={false}
                          resizeType="m_lfit"
                          className="object-fit"
                        />
                        <SuiBox className="overlay">
                          <SuiBox display="flex" alignItems="center" gap={1}>
                            <SuiTypography
                              variant="body1"
                              textTransform="none"
                              color="white"
                              sx={{
                                fontWeight: "bold",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: "2",
                                WebkitBoxOrient: "vertical",
                              }}
                            >
                              {mb?.title}
                            </SuiTypography>{" "}
                          </SuiBox>
                        </SuiBox>
                      </SuiBox>
                    </div>

                    <SuiBox sx={{ my: 0.5, px: 1 }}>
                      <SuiBox display="flex" justifyContent="space-between" alignItems="center">
                        <SuiBox>
                          <SuiTypography
                            variant="body1"
                            textTransform="none"
                            color="dark"
                            sx={{
                              fontWeight: "bold",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: "2",
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {mb?.title}
                          </SuiTypography>
                        </SuiBox>
                      </SuiBox>
                    </SuiBox>
                  </SuiBox>
                );
              })}
            </Masonry>
          </ResponsiveMasonry>
        ) : (
          <Empty />
        )}
      </SuiBox>
    </SuiBox>
  );
};

export default SharedCollectionList;
